import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: typeof LucideIcon;
  title: string;
  description: string;
  meta?: {
    features?: string[];
  };
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon: Icon, title, description, meta }) => {
  return (
    <div className="relative flex items-stretch">
      <div className="bg-gradient-to-br from-[#FF69B4]/15 to-[#FFDAB9]/15 p-6 transition-all duration-300 hover:translate-y-[-3px] group relative w-full rounded-2xl">
        <div className="bg-white p-6 rounded-xl shadow-xl border border-[#FF4E8E]/20">
          <div className="w-12 h-12 rounded-full bg-[#FF4E8E]/10 flex items-center justify-center mb-4">
            <Icon className="h-6 w-6 text-[#FF4E8E]" />
          </div>
          <h3 className="text-[18px] font-bold font-cormorant-garamond mb-2 text-[#1C1C1E]">{title}</h3>
          <p className="text-[15px] font-cormorant-garamond font-normal text-[#535353] mb-4 leading-[1.5]" dangerouslySetInnerHTML={{__html: description.replace(/customizable reminders|real-time tracking/gi, match => `<span class='italic'>${match}</span>`)}} />
          
          {meta?.features && (
            <ul className="space-y-2 mt-4 border-t border-[#FF4E8E]/20 pt-4 font-cormorant-garamond">
              {meta.features.map((feature, index) => (
                <li key={index} className="text-[15px] text-[#535353] flex items-center">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF4E8E]/60 mr-2"></span>
                  {feature}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;